import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState, useEffect } from 'react';
import { Stack, Button, Container, Typography, Box, Card } from '@mui/material';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import { toast } from 'react-toastify';
import { getApi, patchApi } from 'views/services/api';
import AddHotel from './AddHotel';
import ChangePassword from './ChangePassword';


// ----------------------------------------------------------------------

const HotelManagement = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [statusChanged, setStatusChanged] = useState(true);
  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState('');
  const [hotelData, sethotelData] = useState([]);
  const navigate = useNavigate();

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  const handleOpenChangePassword = (email) => {
    setSelectedEmail(email);
    setOpenChangePasswordModal(true);
  };

  const handleCloseChangePasswordModal = () => {
    setOpenChangePasswordModal(false);
    setSelectedEmail('');
  };

  const handleChangePassword = async (newPassword) => {
    try {
      console.log("in handleChangePassword function..................");
      console.log("newPassword ====>",newPassword);
      console.log("Api Hit  ===>",`api/hotel/changehotelpassword`,{ email: selectedEmail, password: newPassword });

      const response = await patchApi('api/hotel/changehotelpassword', { email: selectedEmail, password: newPassword });
      console.log("response aaya ===>",response);

      if (response.status === 200) {
        toast.success('Password changed successfully');
      } else {
        toast.error('Failed to change password');
      }
      handleCloseChangePasswordModal();

    } catch (error) {
      console.error('Error changing password:', error);
      toast.error('Error changing password');
    }
  };

  const handleOpenChangeStatus = async (hotelId) => {
    try {
      const status = !statusChanged
      console.log("status ==>",status);
      console.log("api hit ==>",`api/hotel/changehotelstatus/${hotelId}/${status}`);
      const response = await patchApi(`api/hotel/changehotelstatus/${hotelId}/${status}`);
      console.log("response for status ====>",response);
      
      if (response.status === 200) {
        toast.success('Status Changed Successfully');
        // console.log("statusChanged==>",statusChanged);
        // setStatusChanged((prevStatusChanged) => !prevStatusChanged);
        setStatusChanged(status);
      } else {
        setStatusChanged(false);
        toast.error('Cannot change status');
      }
    } catch (e) {
      setStatusChanged(false);
      console.log(e);
      toast.error('Cannot change status');
    }
  };
  console.log("statusChanged==>",statusChanged);

  const fetchhotelData = async () => {
    try {
      const response = await getApi('api/hotel/viewallhotels');
      console.log("response ===>", response);
      sethotelData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchhotelData();
  }, [statusChanged, openAdd, openChangePasswordModal ]);

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        const handleOpenView = () => {
          navigate(`/dashboard/hotel/view/${params.row._id}`);
        };
        return <Box onClick={handleOpenView}>{params.value}</Box>;
      }
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1
    },
    {
      field: 'contact',
      headerName: 'Contact',
      flex: 1
    },
    {
      field: 'address',
      headerName: 'Address',
      flex: 1
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={
            params?.value === true
              ? {
                backgroundColor: '#01B574',
                color: 'white',
                padding: '4px',
                borderRadius: '5px'
                }
              : {
                  backgroundColor: 'red',
                  color: 'white',
                  padding: '4px',
                  borderRadius: '5px'
                }
          }
        >
          {params?.value === false ? 'Inactive' : 'Active'}
        </Box>
      )
    },
    {
      field: 'changePassword',
      headerName: 'Change Password',
      flex: 1,
      renderCell: (params) => (
        <Button
          sx={{ fontSize: '11px' }}
          variant="contained"
          startIcon={<ChangeCircleIcon />}
          onClick={() => handleOpenChangePassword(params.row.email)}
        >
          Change Password
        </Button>
      )
    },
    {
      field: 'changeshift',
      headerName: 'Change Status',
      flex: 1,
      renderCell: (params) => (
        <Button
          sx={{ fontSize: '11px' }}
          variant="contained"
          startIcon={<ChangeCircleIcon />}
          onClick={() => handleOpenChangeStatus(params.row._id)}
        >
          Change Status
        </Button>
      )
    }
  ];

  return (
    <>
      <AddHotel open={openAdd} handleClose={handleCloseAdd} />
      <ChangePassword
        open={openChangePasswordModal}
        handleClose={handleCloseChangePasswordModal}
        email={selectedEmail}
        onChangePassword={handleChangePassword}
      />
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Hotel Management</Typography>
          <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={2}>
            <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAdd}>
              Add Hotel
            </Button>
          </Stack>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Hotels ( {hotelData?.length || 0} )
              </Typography>
              {hotelData && (
                <DataGrid
                  rows={hotelData}
                  columns={columns}
                  checkboxSelection
                  getRowId={(row) => row?._id}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{ toolbar: { showQuickFilter: true } }}
                />
              )}
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default HotelManagement;

